console.log("Custom JS");

var sizeChartTop = document.getElementById('size-chart-top-level-tags');

if(typeof sizeChartTop != undefined && sizeChartTop != null) {
    var anchors = sizeChartTop.querySelectorAll('a');
    var activeTopLvl = sizeChartTop.querySelector('.active');
    var mainTabs = document.querySelectorAll('.size-chart-tab-top');
    var mainTabActive = document.querySelector('.size-chart-tab-top.active');
    var subTabActive = [], subTabsListActive = [];

    anchors.forEach(function(a) {
        a.addEventListener('click', function(e){
            e.preventDefault();
            
            activeTopLvl.classList.remove('active');
            if(mainTabActive != null) {
                mainTabActive.classList.remove('active');
            }
            mainTabActive = document.getElementById(this.dataset.topLevel);
            mainTabActive.classList.add('active');
            activeTopLvl = e.target;
            this.classList.add('active');
            
        });
    });

    mainTabs.forEach(function(mTab, index) {
        var subTabsList = mTab.querySelectorAll('.sub-tabs a');
        subTabsListActive[index] = mTab.querySelector('.sub-tabs a.active');
        subTabActive[index] = mTab.querySelector('.sub-tab-content.active');

        subTabsList.forEach(function(a){
            a.addEventListener('click', function(e) {
                e.preventDefault();
                subTabsListActive[index].classList.remove('active');
                subTabsListActive[index] = e.target;
                subTabsListActive[index].classList.add('active');

                subTabActive[index].classList.remove('active');
                subTabActive[index] = document.getElementById(this.dataset.subTab);
                subTabActive[index].classList.add('active');
            });
        });
    });
}

document.addEventListener("DOMContentLoaded", function(){
    var inputs = document.querySelectorAll('.form-options input');
    var isbn = document.querySelector('[data-product-isbn]');
    var variants = document.querySelector('select[name="id"]');
    console.log("Test variants");
    console.dir(variants);
    if(typeof inputs != 'undefined' && inputs != null) {
        inputs.forEach(function(input) {
            input.addEventListener('change', function(){
                setTimeout(function() {
                    var variantId = getParameterByName('variant');
                    var foundMatch;
                    Array.from(variants.children).forEach(function(el) {
                        console.dir(el);
                        if(el.dataset.variantId == variantId) {
                            foundMatch = el;
                        }
                    });

                    if(typeof foundMatch != 'undefined') {
                        isbn.innerText = foundMatch.dataset.isbn;
                    }
                }, 10);
            });            
        });
    }
});

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}